import { render } from "./manage-wallet.vue?vue&type=template&id=92ab162c"
import script from "./manage-wallet.vue?vue&type=script&lang=js"
export * from "./manage-wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__